import { render, staticRenderFns } from "./productSalesPriceConfigRulesModal.vue?vue&type=template&id=65e9c750&scoped=true"
import script from "./productSalesPriceConfigRulesModal.vue?vue&type=script&lang=js"
export * from "./productSalesPriceConfigRulesModal.vue?vue&type=script&lang=js"
import style0 from "./productSalesPriceConfigRulesModal.vue?vue&type=style&index=0&id=65e9c750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9c750",
  null
  
)

export default component.exports